import React from 'react';

import { Link } from 'react-router-dom';

import { schemas } from '@recurrency/core-api-schema';
import { McpAccessTokenDTO } from '@recurrency/core-api-schema/dist/users/mcpAccessTokens';
import { Typography } from 'antd';

import { Container } from 'components/Container';
import { CenteredError } from 'components/Loaders';
import { PageHeader } from 'components/PageHeader';
import { McpSessionsTable } from 'components/recipes/McpSessionsTable';

import { useCoreApi } from 'hooks/useApi';
import { useGlobalApp } from 'hooks/useGlobalApp';

import { coreApiFetch } from 'utils/api';
import { routes } from 'utils/routes';

export const MyMcpSessionsPage = () => {
  const { tenants } = useGlobalApp();
  const { data, error, isLoading, reload } = useCoreApi(schemas.users.listMyMcpAccessTokens, {
    queryParams: {},
  });

  const tenantNameById = new Map(tenants.map((tenant) => [tenant.id, tenant.name]));

  const onRevoke = async (token: McpAccessTokenDTO) => {
    await coreApiFetch(schemas.users.revokeMyMcpAccessToken, {
      pathParams: { jti: token.jti },
    });
    reload();
  };

  if (error) {
    return <CenteredError error={error} />;
  }

  return (
    <Container>
      <PageHeader title="MCP Sessions" />
      <Typography.Paragraph type="secondary">
        Active connections from Cursor, Claude, and other MCP clients. To create a session, authorize from your MCP
        client. Profile settings are under <Link to={routes.account.accountEdit()}>Account</Link>.
      </Typography.Paragraph>
      <McpSessionsTable
        items={data?.items ?? []}
        isLoading={isLoading}
        resolveTenantLabel={(tenantId) => tenantNameById.get(tenantId) ?? tenantId}
        onRevoke={onRevoke}
      />
    </Container>
  );
};
